import React, { Component } from 'react'; 
import * as Constants from './api/constants' 
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import ClientsList from './client.component/ClientsList';
import { MainContext } from '../context/MainContext'
import { UserContext } from '../context/UserContext'
export default class Users extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      clientsList: [],
      spinner: false
    };
  }

  getClientsList = (name = '') => {
    const requestOptions = {
      method: 'GET', 
      credentials: "include"
    };
    
    const parameters = new URLSearchParams({
      searchClient: name
    });

    fetch(Constants.baseURL + Constants.apiClientsList + '?' + parameters, requestOptions) 
      .then(response => { 
          if (!response.ok && response.status !== 404) {
              this.props.history.push('/');
          }
          return response.json() })
      .then(data => {  
        this.setState({ 
          clientsList: data.clients,
          spinner: false
        });
      }) 
      .catch(error => { console.log('request failed', error); }); 
  }

  componentDidMount() {
    this._isMounted = true;

    this.setState({
      usersList: [],
      spinner: false
    })

    this.getClientsList();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState = (state,callback)=>{
      return;
    };
  }

  render() {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
    <Grid container spacing={3}>
      {/* ClientsList */}
      <Grid item xs={12} md={12} lg={12}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                height: 713,
              }}
            >
              <UserContext.Provider value={this.props} >
                <MainContext.Provider value={this.state.clientsList} >
                  <ClientsList getClientsList={this.getClientsList} />
                </MainContext.Provider>
              </UserContext.Provider>
            </Paper>
          </Grid>
    </Grid>
    <Copyright sx={{ pt: 4 }} />
  </Container>);
  }
}